const checkBoxValidation = (val) => {
    if (!val) {
        return true;
    }
    let validationFail = Object.values(val).every((value) => value === false);
    return !validationFail;
};

export { checkBoxValidation };
